import { render, staticRenderFns } from "./management-workspace-list.vue?vue&type=template&id=4c499b69"
import script from "./management-workspace-list.vue?vue&type=script&lang=js"
export * from "./management-workspace-list.vue?vue&type=script&lang=js"
import style0 from "./management-workspace-list.vue?vue&type=style&index=0&id=4c499b69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports